jQuery(document).ready(function($) {
  new Swiper('.rooms .image_slider.swiper, .rooms .content_slider.swiper', {
    loop: true,
    allowTouchMove: false,
    slidesPerView: 1,
    speed: 500,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.rooms .slider-next',
      prevEl: '.rooms .slider-prev',
    },
  })
})